export class BonePriorityList {
    constructor(initialList = []) {
      this.list = [];
      
      initialList.forEach(bone => {
        if (bone.endsWith('s') && !bone.startsWith('l') && !bone.startsWith('r')) {
          // Handle plural form
          const base = bone.slice(0, -1);
          this._addBone(`l${base[0].toUpperCase()}${base.slice(1)}`);
          this._addBone(`r${base[0].toUpperCase()}${base.slice(1)}`);
        } else {
          // Handle singular form
          this._addBone(bone);
        }
      });
    }
  
    _addBone(bone) {
      if (!this.list.includes(bone)) {
        this.list.push(bone);
      }
    }
    getBoneIndex(boneName){
      return this.list.indexOf(boneName);
    }
    /*
    getBoneIndex(boneName) {
      // Handle plural input (e.g. "shoulders")
      if (boneName.endsWith('s') && !boneName.startsWith('l') && !boneName.startsWith('r')) {
        const base = boneName.slice(0, -1);
        const leftIndex = this.list.indexOf(`l${base[0].toUpperCase()}${base.slice(1)}`);
        const rightIndex = this.list.indexOf(`r${base[0].toUpperCase()}${base.slice(1)}`);
        
        // Return the first found index if any pair exists
        if (leftIndex !== -1) return leftIndex;
        if (rightIndex !== -1) return rightIndex;
        return -1;
      }
      
      // Handle singular input (e.g. "lShoulder" or "shoulder")
      if (boneName.startsWith('l') || boneName.startsWith('r')) {
        // Exact match for l/r prefixed bones
        return this.list.indexOf(boneName);
      } else {
        // Try both left and right versions
        const leftVersion = `l${boneName[0].toUpperCase()}${boneName.slice(1)}`;
        const rightVersion = `r${boneName[0].toUpperCase()}${boneName.slice(1)}`;
        
        const leftIndex = this.list.indexOf(leftVersion);
        if (leftIndex !== -1) return leftIndex;
        
        return this.list.indexOf(rightVersion);
      }
    }*/
  
    getDisplayList() {
        const result = [];
        const skipIndices = new Set();
    
        for (let i = 0; i < this.list.length; i++) {
          if (skipIndices.has(i)) continue;
    
          const current = this.list[i];
          
          // Cek apakah current bone punya pasangan dan berurutan
          if (current.startsWith('l')) {
            const rightVersion = 'r' + current.slice(1);
            const nextIndex = i + 1;
            
            // Pastikan pasangan ada dan berada tepat setelahnya
            if (nextIndex < this.list.length && this.list[nextIndex] === rightVersion) {
              result.push(current.slice(1).toLowerCase() + 's');
              skipIndices.add(nextIndex); // Skip pasangan berikutnya
              continue;
            }
          }
          
          // Tambahkan bone biasa jika tidak ada pasangan berurutan
          result.push(current);
        }
    
        return result;
    }
  
    add(bone, index = null) {
        // Handle plural input
        if (bone.endsWith('s') && !bone.startsWith('l') && !bone.startsWith('r')) {
          const base = bone.slice(0, -1);
          this._addSingleBone(`l${base[0].toUpperCase()}${base.slice(1)}`, index);
          this._addSingleBone(`r${base[0].toUpperCase()}${base.slice(1)}`, index !== null ? index + 1 : null);
          return;
        }
    
        // Handle singular input
        this._addSingleBone(bone, index);
      }
    
      _addSingleBone(bone, targetIndex = null) {
        // Remove existing bone (both l/r versions if paired)
        this.remove(bone);
    
        // Determine insert position
        const insertAt = targetIndex !== null 
          ? Math.min(Math.max(targetIndex, 0), this.list.length)
          : this.list.length;
    
        this.list.splice(insertAt, 0, bone);
    }
  
    remove(bone) {
      this.list = this.list.filter(b => b !== bone);
    }
  
    getList() {
      return [...this.list];
    }
  }